/* ===========================================================
   JOUBERT — Le panier : la modale « produit ajouté », la page panier,
   et la quantité repliée derrière « Modifier » qu'elles partagent.

   Tout passe par les événements du thème : variant:add pour ouvrir la
   modale, cart:change pour tenir l'icône de l'en-tête à jour. Les
   lignes se modifient par cart/change.js, puis le fragment concerné
   est redemandé au Section Rendering API : le Liquid reste la seule
   source du rendu.
   =========================================================== */

(function () {
  'use strict';

  var racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SOBRE = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- Outils ---------- */

  /* Klarna : sa bibliothèque remet sur les emplacements le montant
     qu'elle a connu au premier rendu, à chaque appel au panier. Le bon
     montant est porté par data-jb-montant ; un observateur le rétablit
     dès qu'elle l'écrase, puis lui demande de redessiner. */
  function klarnaRafraichit() {
    try {
      if (window.Klarna && window.Klarna.OnsiteMessaging) window.Klarna.OnsiteMessaging.refresh();
    } catch (e) { /* Klarna absent : rien à rafraîchir */ }
  }

  function klarnaRetablit(zone) {
    var corrige = false;
    zone.querySelectorAll('klarna-placement[data-jb-montant]').forEach(function (k) {
      if (k.getAttribute('data-purchase-amount') !== k.dataset.jbMontant) {
        k.setAttribute('data-purchase-amount', k.dataset.jbMontant);
        corrige = true;
      }
    });
    return corrige;
  }

  function klarnaGarde(zone) {
    if (!zone || zone.dataset.jbKlarnaGarde) return;
    zone.dataset.jbKlarnaGarde = 'oui';
    new MutationObserver(function () {
      if (klarnaRetablit(zone)) klarnaRafraichit();
    }).observe(zone, { attributes: true, subtree: true, attributeFilter: ['data-purchase-amount'] });
  }

  function klarna(zone) {
    klarnaGarde(zone);
    window.setTimeout(function () {
      if (zone) klarnaRetablit(zone);
      klarnaRafraichit();
    }, 80);
  }

  /* Le protocole du thème : avant un changement, on lui demande quelles
     sections il veut voir rendues avec le panier (son tiroir s'inscrit),
     puis on annonce cart:change avec le panier ainsi complété. Le point
     de l'icône panier et le compteur de l'en-tête suivent. */
  async function change(cle, quantite) {
    var preparation = new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: [] } });
    document.documentElement.dispatchEvent(preparation);
    var corps = { id: cle, quantity: quantite };
    if (preparation.detail.sections.length) corps.sections = preparation.detail.sections.join(',');
    var reponse = await fetch(racine + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(corps)
    });
    var panier = await reponse.json();
    if (!reponse.ok) throw new Error(panier.description || 'cart/change');
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: { baseEvent: 'line-item:change', cart: panier }
    }));
    return panier;
  }

  /* Le fragment est lu dans un document inerte (DOMParser) : dans le
     document vivant, les éléments personnalisés du thème s'y
     construiraient une première fois — la barre de livraison offerte
     multiplie son seuil par 100 dans son constructeur et le réécrit,
     un second passage donnait 39 000 € au lieu de 390. */
  async function fragment(chemin, id) {
    var reponse = await fetch(chemin + (chemin.indexOf('?') === -1 ? '?' : '&') + 'sections=' + id, { cache: 'no-store' });
    var json = await reponse.json();
    return new DOMParser().parseFromString(json[id] || '', 'text/html').body;
  }

  /* ---------- La case CGV et le bouton de paiement ---------- */

  function zoneDe(el) { return el.closest('[data-jb-pm], [data-jb-p]'); }

  function cgvOk(zone) {
    var c = zone && zone.querySelector('[data-jb-cgv-case]');
    return !!(c && c.checked);
  }

  function rappelle(zone) {
    var cgv = zone.querySelector('[data-jb-cgv]');
    if (!cgv) return;
    var rappel = cgv.querySelector('[data-jb-cgv-rappel]');
    if (rappel) rappel.hidden = false;
    cgv.removeAttribute('data-secoue');
    void cgv.offsetWidth;
    cgv.setAttribute('data-secoue', '');
    if (zone.hasAttribute('data-jb-p')) cgv.scrollIntoView({ block: 'center', behavior: SOBRE.matches ? 'auto' : 'smooth' });
  }

  /* L'acceptation est écrite dans le panier (attribut de commande) :
     elle apparaît sur la commande dans l'admin, avec la date et
     l'heure, comme le faisait l'app. Le départ vers le paiement attend
     que cette écriture soit faite. */
  var cgvEcriture = Promise.resolve();
  function cgvEcrit(accepte) {
    var valeur = '';
    if (accepte) {
      var d = new Date();
      var deux = function (n) { return (n < 10 ? '0' : '') + n; };
      valeur = 'Acceptées le ' + deux(d.getDate()) + '/' + deux(d.getMonth() + 1) + '/' + d.getFullYear() + ' à ' + deux(d.getHours()) + ':' + deux(d.getMinutes()) + ' (' + d.toISOString() + ')';
    }
    cgvEcriture = fetch(racine + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ attributes: { 'Conditions générales de vente': valeur } })
    }).catch(function () { /* on n'empêche pas le paiement pour autant */ });
    return cgvEcriture;
  }

  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-jb-cgv-case]')) return;
    var zone = zoneDe(e.target);
    if (!zone) return;
    cgvEcrit(e.target.checked);
    if (e.target.checked) {
      zone.setAttribute('data-cgv-ok', '');
      var rappel = zone.querySelector('[data-jb-cgv-rappel]');
      if (rappel) rappel.hidden = true;
      var cgv = zone.querySelector('[data-jb-cgv]');
      if (cgv) cgv.removeAttribute('data-secoue');
    } else {
      zone.removeAttribute('data-cgv-ok');
    }
  });

  /* En phase de capture, avant tout autre écouteur : l'app de CGV
     encore installée ne doit pas parler à notre place. */
  document.addEventListener('click', function (e) {
    var cta = e.target.closest('[data-jb-cta]');
    if (!cta) return;
    e.preventDefault();
    e.stopPropagation();
    var zone = zoneDe(cta);
    if (cgvOk(zone)) versPaiement(cta.dataset.href, zone);
    else rappelle(zone);
  }, true);

  /* Le départ vers le paiement est annoncé à la page (jb:checkout) :
     la mesure d'audience et le pixel Meta y accrochent leur événement,
     comme ils le faisaient sur l'ancien formulaire du panier. */
  function versPaiement(href, zone) {
    var entree = zone && zone.hasAttribute('data-jb-pm') ? 'modale' : 'cart';
    try { document.dispatchEvent(new CustomEvent('jb:checkout', { detail: { entree: entree } })); } catch (e) { /* rien */ }
    var part = function () { window.location.href = href; };
    Promise.race([cgvEcriture, new Promise(function (r) { window.setTimeout(r, 1500); })]).then(part, part);
  }

  /* ---------- La quantité, repliée derrière « Modifier » ---------- */

  var recharges = {}; /* comment recharger chaque zone après un changement */

  document.addEventListener('click', async function (e) {
    var bouton = e.target.closest('[data-jb-qte-modifier], [data-jb-qte-moins], [data-jb-qte-plus], [data-jb-supprimer]');
    if (!bouton) return;
    var article = bouton.closest('[data-jb-article]');
    if (!article) return;

    if (bouton.hasAttribute('data-jb-qte-modifier')) {
      var compteur = article.querySelector('[data-jb-qte-compteur]');
      var ouvert = compteur.hidden;
      compteur.hidden = !ouvert;
      bouton.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
      bouton.parentElement.hidden = ouvert;
      if (ouvert) compteur.querySelector('[data-jb-qte-plus]').focus();
      return;
    }

    var quantite = parseInt(article.dataset.qte, 10) || 1;
    if (bouton.hasAttribute('data-jb-qte-moins')) quantite -= 1;
    else if (bouton.hasAttribute('data-jb-qte-plus')) quantite += 1;
    else quantite = 0;
    if (quantite < 0) return;

    var zone = zoneDe(article);
    article.setAttribute('data-occupe', '');
    if (quantite === 0) {
      /* La ligne s'efface pendant que le panier se met à jour. */
      article.setAttribute('data-part', '');
      await new Promise(function (r) { window.setTimeout(r, SOBRE.matches ? 0 : 230); });
    }
    try {
      await change(article.dataset.cle, quantite);
      var recharge = zone && recharges[zone.hasAttribute('data-jb-pm') ? 'modale' : 'page'];
      if (recharge) await recharge(article.dataset.cle, quantite);
    } catch (err) {
      article.removeAttribute('data-occupe');
    }
  });

  /* ---------- La note à l'atelier ---------- */

  var noteMinuteur = null;

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-jb-note-ouvrir]');
    if (!b) return;
    var note = b.closest('[data-jb-note]');
    var champ = note.querySelector('[data-jb-note-champ]');
    var ouvert = !champ.hasAttribute('data-ouvert');
    if (ouvert) champ.setAttribute('data-ouvert', ''); else champ.removeAttribute('data-ouvert');
    b.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
    if (ouvert) {
      /* Le focus vient une fois le champ déplié, et sans preventScroll :
         c'est ce défilement-là qui, au téléphone, remonte le champ
         au-dessus du clavier. Si le clavier arrive après, on remonte
         encore. */
      window.setTimeout(function () {
        var texte = note.querySelector('[data-jb-note-texte]');
        texte.focus();
        if (window.visualViewport) {
          var remonte = function () { texte.scrollIntoView({ block: 'center', behavior: SOBRE.matches ? 'auto' : 'smooth' }); };
          window.visualViewport.addEventListener('resize', remonte, { once: true });
          window.setTimeout(function () { window.visualViewport.removeEventListener('resize', remonte); }, 1500);
        }
      }, 320);
    }
  });

  /* La note part d'elle-même, un souffle après la dernière frappe. */
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-jb-note-texte]')) return;
    var champ = e.target;
    var note = champ.closest('[data-jb-note]');
    window.clearTimeout(noteMinuteur);
    noteMinuteur = window.setTimeout(async function () {
      var etat = note.querySelector('[data-jb-note-etat]');
      try {
        var reponse = await fetch(racine + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ note: champ.value })
        });
        if (!reponse.ok) throw new Error('cart/update');
        if (champ.value.trim()) note.setAttribute('data-jb-note-pleine', '');
        else note.removeAttribute('data-jb-note-pleine');
        /* Rien à dire quand ça marche : la note part avec la commande,
           pas avant. Seul un échec se signale. */
        if (etat) etat.textContent = '';
      } catch (err) {
        if (etat) etat.textContent = champ.dataset.erreur || '';
      }
    }, 700);
  });

  /* Au remplacement d'un contenu, la note ouverte et son texte en cours
     de frappe reviennent tels quels. */
  function noteSauve(zone) {
    var champ = zone.querySelector('[data-jb-note-champ]');
    var texte = zone.querySelector('[data-jb-note-texte]');
    return champ ? { ouvert: champ.hasAttribute('data-ouvert'), texte: texte ? texte.value : '', focus: document.activeElement === texte } : null;
  }

  function noteRend(zone, etat) {
    if (!etat) return;
    var note = zone.querySelector('[data-jb-note]');
    if (!note) return;
    var champ = note.querySelector('[data-jb-note-champ]');
    var texte = note.querySelector('[data-jb-note-texte]');
    var b = note.querySelector('[data-jb-note-ouvrir]');
    if (etat.ouvert) { champ.setAttribute('data-ouvert', ''); b.setAttribute('aria-expanded', 'true'); }
    if (texte && etat.texte !== undefined) texte.value = etat.texte;
    if (etat.focus && texte) texte.focus();
  }

  /* ---------- Le panier en modale ---------- */

  var pm = document.querySelector('[data-jb-pm]');

  if (pm) {
    klarnaGarde(pm);
    var feuille = pm.querySelector('.jb-pm__feuille');
    var ouverte = false;
    var retour = null; /* l'élément à qui rendre le focus */
    var minuteur = null;

    /* Le contenu sous l'en-tête est remplacé d'un bloc : lignes,
       total, Klarna, case CGV, bouton. La case cochée et les
       compteurs dépliés survivent au remplacement. */
    async function rechargeModale() {
      var deplies = {};
      pm.querySelectorAll('[data-jb-article]').forEach(function (a) {
        if (!a.querySelector('[data-jb-qte-compteur]').hidden) deplies[a.dataset.cle] = true;
      });
      var cgv = cgvOk(pm);
      var note = noteSauve(pm);

      var bac = await fragment(racine, 'joubert-panier-modale');
      var neuf = bac.querySelector('[data-jb-pm-contenu]');
      if (!neuf) return;
      pm.querySelector('[data-jb-pm-contenu]').innerHTML = neuf.innerHTML;

      if (cgv) {
        var c = pm.querySelector('[data-jb-cgv-case]');
        if (c) { c.checked = true; pm.setAttribute('data-cgv-ok', ''); }
      } else {
        pm.removeAttribute('data-cgv-ok');
      }
      pm.querySelectorAll('[data-jb-article]').forEach(function (a) {
        if (deplies[a.dataset.cle]) {
          a.querySelector('[data-jb-qte-compteur]').hidden = false;
          a.querySelector('[data-jb-qte-modifier]').parentElement.hidden = true;
        }
      });
      noteRend(pm, note);
      klarna(pm);
    }
    recharges.modale = rechargeModale;

    function ouvre(mode) {
      pm.dataset.mode = mode;
      if (ouverte) return;
      ouverte = true;
      window.clearTimeout(minuteur);
      pm.hidden = false;
      void pm.offsetHeight;
      pm.classList.add('jb-pm--ouverte');
      document.documentElement.classList.add('jb-pm-ouverte');
      /* Le bouton retour du téléphone doit fermer la modale, pas
         quitter la page : elle pose sa propre entrée d'historique. */
      try { window.history.pushState({ jbPm: true }, ''); } catch (e) { /* historique verrouillé */ }
      klarna(pm);
      window.setTimeout(function () { feuille.focus(); }, SOBRE.matches ? 0 : 200);
    }

    function ferme(parHistorique) {
      if (!ouverte) return;
      ouverte = false;
      pm.classList.remove('jb-pm--ouverte');
      document.documentElement.classList.remove('jb-pm-ouverte');
      minuteur = window.setTimeout(function () { pm.hidden = true; }, SOBRE.matches ? 0 : 450);
      if (!parHistorique && window.history.state && window.history.state.jbPm) window.history.back();
      if (retour && document.contains(retour)) retour.focus({ preventScroll: true });
      retour = null;
    }

    window.addEventListener('popstate', function () { if (ouverte) ferme(true); });

    pm.addEventListener('click', function (e) {
      if (e.target.closest('[data-jb-pm-ferme]')) ferme(false);
    });

    document.addEventListener('keydown', function (e) {
      if (!ouverte) return;
      if (e.key === 'Escape') { e.preventDefault(); ferme(false); return; }
      if (e.key !== 'Tab') return;
      /* Le focus tourne dans la feuille. */
      var focalisables = feuille.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (!focalisables.length) return;
      var premier = focalisables[0], dernier = focalisables[focalisables.length - 1];
      if (e.shiftKey && (document.activeElement === premier || document.activeElement === feuille)) { e.preventDefault(); dernier.focus(); }
      else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
    });

    /* À l'ajout d'un produit : « Produit ajouté au panier ». */
    document.addEventListener('variant:add', async function (e) {
      var items = (e.detail && e.detail.items) || [];
      if (!items.length) return;
      retour = document.activeElement;
      try { await rechargeModale(); } catch (err) { return; }
      ouvre('ajout');
    });

    /* Depuis l'icône panier de l'en-tête : « Panier ». Le lien reste
       un lien vers la page pour qui n'a pas de script. */
    document.addEventListener('click', async function (e) {
      var lien = e.target.closest('.header a[href], .header-sidebar a[href]');
      if (!lien) return;
      var href = lien.getAttribute('href') || '';
      if (!/\/cart\/?(\?|#|$)/.test(href)) return;
      e.preventDefault();
      e.stopPropagation();
      if (ouverte) return;
      retour = lien;
      try { await rechargeModale(); } catch (err) { window.location.href = href; return; }
      ouvre('panier');
    }, true);
  }

  /* ---------- La page panier ---------- */

  var page = document.querySelector('[data-jb-p]');

  if (page) {
    klarnaGarde(page);
    var sectionId = page.dataset.section;

    async function rechargePage() {
      var deplies = {};
      page.querySelectorAll('[data-jb-article]').forEach(function (a) {
        if (!a.querySelector('[data-jb-qte-compteur]').hidden) deplies[a.dataset.cle] = true;
      });
      var bac = await fragment(window.location.pathname, sectionId);
      var neuf = bac.querySelector('[data-jb-p]');
      if (!neuf) return;
      var cgv = cgvOk(page);
      var note = noteSauve(page);
      page.innerHTML = neuf.innerHTML;
      noteRend(page, note);
      if (cgv) {
        var c = page.querySelector('[data-jb-cgv-case]');
        if (c) { c.checked = true; page.setAttribute('data-cgv-ok', ''); }
      }
      page.querySelectorAll('[data-jb-article]').forEach(function (a) {
        if (deplies[a.dataset.cle]) {
          a.querySelector('[data-jb-qte-compteur]').hidden = false;
          a.querySelector('[data-jb-qte-modifier]').parentElement.hidden = true;
        }
      });
      klarna(page);
      mesure();
    }
    recharges.page = rechargePage;

    /* Le rappel fixe : total et bouton, tant que le vrai bouton n'est
       pas à l'écran. Mesuré au défilement, comme la barre de la fiche. */
    var attente = false;
    function mesure() {
      attente = false;
      var fixe = page.querySelector('[data-jb-p-fixe]');
      var cta = page.querySelector('[data-jb-cta]');
      if (!fixe || !cta) { document.body.classList.remove('jb-barre-visible'); return; }
      var r = cta.getBoundingClientRect();
      var visible = r.bottom > 0 && r.top < window.innerHeight;
      var montre = !visible && window.matchMedia('(max-width: 749px)').matches;
      fixe.classList.toggle('jb-p__fixe--visible', montre);
      fixe.setAttribute('aria-hidden', montre ? 'false' : 'true');
      /* Le bouton de conversation se pose au-dessus, comme sur la fiche. */
      document.body.classList.toggle('jb-barre-visible', montre);
      document.body.style.setProperty('--jb-h-barre', fixe.offsetHeight + 'px');
    }
    window.addEventListener('scroll', function () {
      if (attente) return;
      attente = true;
      window.requestAnimationFrame(mesure);
    }, { passive: true });
    window.addEventListener('resize', mesure);
    mesure();

    page.addEventListener('click', function (e) {
      if (!e.target.closest('[data-jb-p-fixe-bouton]')) return;
      var cta = page.querySelector('[data-jb-cta]');
      if (!cta) return;
      if (cgvOk(page)) versPaiement(cta.dataset.href, page);
      else rappelle(page);
    });
  }
})();
